import React, { useRef, useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { exportComponentAsPNG } from 'react-component-export-image';

import QRCode from 'react-qr-code';
import Barcode from 'react-jsbarcode';
import ReactToPrint from 'react-to-print';
import axios from 'axios';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

import './Passport.scss';
import PassportLogo from '../assets/passport-logo.png';
import { ReactComponent as LoadIcon } from '../assets/load.svg';
import { ReactComponent as ErrorIcon } from '../assets/404.svg';

// A custom hook that builds on useLocation to parse
function useQuery() {
    return new URLSearchParams(useLocation().search);
}

///const AppApi = 'http://10.77.78.105:9000/dev/v1';
const AppApi = 'https://snrutrack.snru.ac.th/dev/v1';
const AppSwal = withReactContent(Swal);

const fetchUser = (id) => axios.get(`${AppApi}/passport?userID=${id}`);

function Passport() {

    const usequery = useQuery();
    const componentRef = useRef();
    const uID = usequery.get('userID');

    const [isload, setisLoad] = useState(false);
    const [iserror, setisError] = useState(false);
    const [userID, setuserID] = useState('');
    const [user, setUser] = useState([]);

    async function onMessage(icon, msg) {
        await AppSwal.fire({
            icon: icon,
            title: <p>{msg}</p>,
            footer: 'SNRU TRACKING V3.0 @MIS',
        });
    }

    function loadError() {
        onMessage('error', `ไม่พบผู้ใช้งานโปรดลองอีกครั้ง`);
        setisLoad(false);
        setuserID('');
    }

    function loadUser() {
        fetchUser(userID)
            .then((response) => {
                if (response.status === 200) {
                    setUser(response.data);
                    setisLoad(true);
                } else {
                    loadError();
                }
            })
            .catch(() => {
                loadError();
            });
    }

    useEffect(() => {
        function Error() {
            onMessage('error', `ไม่พบผู้ใช้งานโปรดลองอีกครั้ง`);
            setuserID('');
            setisError(true);
        }
        if (uID !== null) {
            setuserID(uID);
            fetchUser(uID)
                .then((response) => {
                    if (response.status === 200) {
                        setUser(response.data);
                        setisLoad(true);
                    } else {
                        Error();
                    }
                })
                .catch(() => {
                    Error();
                });
        }
    }, [uID]);

    return (
        <div className="flex h-screen">
            <div className="m-auto">
                {
                    isload ? (
                        <div id="passport" >
                            <div id="ticket" ref={componentRef}>
                                <div className="row qr p-4 flex flex-col items-center perforated destinations">
                                    <div className="sec">
                                        <div className="label">QRcode </div>
                                    </div>
                                    <QRCode
                                        value={user.profile.username}
                                        size={150}
                                    />
                                </div>
                                <div className="row p-4">
                                    <div className="sec">
                                        <div className="label">ชื่อ-นามสกุล</div>
                                        <div className="text">{user.profile.display}</div>
                                    </div>
                                </div>
                                <div className="row flex flex-row justify-between p-4">
                                    <div className="sec">
                                        <div className="label">ประเภท</div>
                                        <div className="text">{user.profile.agency}</div>
                                    </div>
                                    <div className="sec">
                                        <div className="label">สถานะวัคซีน</div>
                                        <div className="text">{user.status.vaccine}</div>
                                    </div>
                                </div>
                                <div className="row flex flex-row justify-between p-4 perforated">
                                    <div className="sec">
                                        <div className="label">หน่วยงาน</div>
                                        <div className="text">มหาวิทยาลัยราชภัฏสกลนคร</div>
                                    </div>
                                </div>
                                <div className="row barcode p-4 perforated">
                                    <div className="label">BARCODE</div>
                                    <Barcode value={userID} options={{ height: '65' }} />
                                </div>
                                <div className="row flex flex-row justify-between p-4">
                                    <img className="logo-b" alt="" src={PassportLogo} />
                                    <div className="right">
                                        <div className="label">SNRUTRACK</div>
                                        <div className="text">PASSPORT</div>
                                    </div>
                                </div>
                            </div>
                            <div className="print text-center p-4">

                                <button onClick={() => exportComponentAsPNG(componentRef, { fileName: 'PASSPORT-SNRUTRACK' })}>
                                    บันทึกไว้ในเครื่อง
                                </button>
                                <span className="p-2">|</span>
                                <ReactToPrint
                                    trigger={() => <button> พิมพ์</button>}
                                    content={() => componentRef.current}
                                />

                            </div>
                        </div>
                    ) : (
                        uID ? (
                            <div className="app">
                                {iserror ? (
                                    <div className="error">
                                        <ErrorIcon className="m-auto" />
                                        <p>ไม่พบผู้ใช้งานโปรดลองอีกครั้ง....</p>
                                    </div>
                                ) : (
                                    <div className="loding">
                                        <LoadIcon className="m-auto" />
                                        <p>กำลังโหลดข้อมูล....</p>
                                    </div>
                                )}
                            </div>
                        ) : (
                            <div className="genareter">
                                <div className="title mb-4 text-center">
                                    <h1 className="text-3xl">SNRU PASSPORT</h1>
                                </div>
                                <div className="bg-white shadow-md rounded lg:w-96 md:w-80 sm:w-80 px-8 pt-6 pb-8 mb-4">
                                    <div className="mb-4">
                                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="username">ชื่อผู้ใช้งาน</label>
                                        <input
                                            className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                            id="username"
                                            type="text"
                                            placeholder="เลขบัตรประชาชน / รหัสนักศึกษา"
                                            onChange={e => setuserID(e.target.value)}
                                            value={userID}
                                            onKeyPress={event => {
                                                if (event.key === 'Enter') {
                                                    loadUser();
                                                }
                                            }}
                                        />
                                    </div>
                                    <div className="flex items-center justify-between">
                                        <button
                                            className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline"
                                            type="button"
                                            onClick={loadUser}>
                                            สร้าง Passport
                                        </button>
                                    </div>
                                </div>
                            </div>
                        )
                    )
                }
            </div>
        </div >

    )
}
export default Passport;